<template>
  <div>
    <div class="row">
      <div v-show="HasShowMenuCfg" class="col-md-3" style="border: solid 1px #ccc; background-color:#fff;right: 2px; height: 1100px">
        <!--MENU CONF-->
        <nav class="sidebar-nav pb-5">
          <label class="text-muted pt-2"><strong>{{$lang.Menu.Common.Menu}}</strong></label>
          <br>
          <label class="text-muted pt-2" v-if="hasRole(this.roles.RW_CFG_AREA) || hasRole(this.roles.RW_CFG_BANK) || hasRole(this.roles.RW_CFG_HOLIDAY)"><strong><small>{{$lang.Menu.Items.Configuration.General}}</small></strong></label>
          <ul class="nav" style="display:block;">
            <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_AREA)">
              <router-link :to="{ name: 'Area' }" class="nav-link" exact>
                <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.Area}}
              </router-link>
            </li>
            <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_BANK)">
              <router-link :to="{ name: 'Banco' }" class="nav-link" exact>
                <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.Banks}}
              </router-link>
            </li>
            <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_HOLIDAY)">
              <router-link :to="{ name: 'Feriados' }" class="nav-link" exact>
                <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.Holidays}}
              </router-link>
            </li>
          </ul>
          <label class="text-muted pt-2" v-if="hasRole(this.roles.RW_CFG_BRANCH)"><strong><small>{{$lang.Menu.Items.Configuration.Institutional}}</small></strong></label>
          <ul class="nav" style="display:block;">
            <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_BRANCH)">
              <router-link :to="{ name: 'Filiais' }" class="nav-link" exact>
                <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.Branch}}
              </router-link>
            </li>
          </ul>
          <label class="text-muted pt-2" v-if="hasRole(this.roles.RW_CFG_INSURERS) || hasRole(this.roles.RW_CFG_BUSINESSTYPE) || hasRole(this.roles.RW_CFG_INSURED)"><strong><small>{{$lang.Menu.Items.Configuration.Clients}}</small></strong></label>
          <ul class="nav" style="display:block;">
            <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_INSURERS)">
              <router-link :to="{ name: 'Seguradora' }" class="nav-link" exact>
                <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.Insurer}}
              </router-link>
            </li>
            <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_BUSINESSTYPE)">
              <router-link :to="{ name: 'TipoNegocio' }" class="nav-link" exact>
                <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.BusinessType}}
              </router-link>
            </li>
            <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_INSURED)">
              <router-link :to="{ name: 'Segurado' }" class="nav-link" exact>
                <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.Insured}}
              </router-link>
            </li>
          </ul>
          <ul class="nav" style="display:block;">
            <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_BRANCH)">
              <router-link :to="{ name: 'Produtos' }" class="nav-link" exact>
                <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.Product}}
              </router-link>
            </li>
          </ul>
          <label class="text-muted pt-2" v-if="hasRole(this.roles.RW_CFG_EXPERT) || hasRole(this.roles.RW_CFG_SERVICEREGIONS)"><strong><small>{{$lang.Menu.Items.Configuration.Roles}}</small></strong></label>
          <ul class="nav" style="display:block;">
            <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_EXPERT)">
              <router-link :to="{ name: 'Perito' }" class="nav-link" exact>
                <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.Expert}}
              </router-link>
            </li>
            <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_SERVICEREGIONS)">
              <router-link :to="{ name: 'RegioesAtendimento' }" class="nav-link" exact>
                <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.RegionsService}}
              </router-link>
            </li>
          </ul>
          <label class="text-muted pt-2" v-if="hasRole(this.roles.RW_CFG_STAGES) || hasRole(this.roles.RW_CFG_REGULATIONTYPE) || hasRole(this.roles.RW_CFG_DOCUMENTTYPE) || hasRole(this.roles.RW_CFG_IMAGESTTYPE) || hasRole(this.roles.RW_CFG_BUDGETSYSTEM)"><strong><small>{{$lang.Menu.Items.Configuration.Regulation}}</small></strong></label>
          <ul class="nav" style="display:block;">
            <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_STAGES)">
              <router-link :to="{ name: 'Estagio' }" class="nav-link" exact>
                <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.Stages}}
              </router-link>
            </li>
            <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_REGULATIONTYPE)">
              <router-link :to="{ name: 'TipoVistoria' }" class="nav-link" exact>
                <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.InspectionType}}
              </router-link>
            </li>
            <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_DOCUMENTTYPE)">
              <router-link :to="{ name: 'TipoDocumento' }" class="nav-link" exact>
                <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.TypeDocuments}}
              </router-link>
            </li>
            <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_IMAGESTTYPE)">
              <router-link :to="{ name: 'TipoImage' }" class="nav-link" exact>
                <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.TypeImages}}
              </router-link>
            </li>
            <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_BUDGETSYSTEM)">
              <router-link :to="{ name: 'SistemaOrcamentacao' }" class="nav-link" exact>
                <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.BudgetSystem}}
              </router-link>
            </li>
          </ul>
          <label class="text-muted pt-2" v-if="hasRole(this.roles.RW_CFG_SCHEDULINGTYPE) || hasRole(this.roles.RW_CFG_SCHEDULINGCONTACT)"><strong><small>{{$lang.Menu.Items.Configuration.Scheduling}}</small></strong></label>
          <ul class="nav" style="display:block;">
            <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_SCHEDULINGTYPE)">
              <router-link :to="{ name: 'FormasVistoria' }" class="nav-link" exact>
                <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.SchedulingType}}
              </router-link>
            </li>
            <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_SCHEDULINGCONTACT)">
              <router-link :to="{ name: 'ContatoVistoria' }" class="nav-link" exact>
                <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.SchedulingContact}}
              </router-link>
            </li>
          </ul>
          <label class="text-muted pt-2" v-if="hasRole(this.roles.RW_CFG_WORKSHOP) || hasRole(this.roles.RW_CFG_AUTOTYPE) || hasRole(this.roles.RW_CFG_AUTOBRAND) || hasRole(this.roles.RW_CFG_AUTOMODEL)"><strong><small>{{$lang.Menu.Items.Configuration.Expertise}}</small></strong></label>
          <ul class="nav" style="display:block;">
            <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_WORKSHOP)">
              <router-link :to="{ name: 'Oficina-Cfg' }" class="nav-link" exact>
                <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.MechanicalWorkshop}}
              </router-link>
            </li>
            <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_AUTOTYPE)">
              <router-link :to="{ name: 'TipoVeiculo' }" class="nav-link" exact>
                <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.TypeVehicle}}
              </router-link>
            </li>
            <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_AUTOBRAND)">
              <router-link :to="{ name: 'Fabricante' }" class="nav-link" exact>
                <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.Brand}}
              </router-link>
            </li>
            <li class="nav-item" v-if="hasRole(this.roles.RW_CFG_AUTOMODEL)">
              <router-link :to="{ name: 'Modelo' }" class="nav-link" exact>
                <i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.Model}}
              </router-link>
            </li>
          </ul>
        </nav>
        <!--END MENU CONF-->
      </div>
      <div v-bind:class="[HasShowMenuCfg ? 'col-md-9': 'col-md-12']">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
import PermissionMixin from '@/store/module/permission/mixin'
import Roles from '@/shared/utils/roles.js'

export default {
  name: 'configuration',
  mixins: [ PermissionMixin ],
  data () {
    return {
      roles: Roles
    }
  },
  props: {
    showMenuCfg: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    HasShowMenuCfg: function () {
      return this.showMenuCfg
    }
  },
  methods: {
    hasRole (role) {
      var result = false
      if (this.permissions) {
        for (var i in this.permissions) {
          if (this.permissions[i].role === role) {
            result = true
          }
        }
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configuration/configuration.vue